import CDNLink from "@/components/CDNLink/CDNLink";
import PDFViewer, { PDFHighlight } from "@/components/PDFViewer/PDFViewer";
import { AssetTypes } from "@/model/AssetTypes";
import { Invoice } from "../RAInterfaces";
// import './InvoicePDF.scss';

interface InvoicePDFProps {
  invoice: Invoice;
  highlights?: PDFHighlight[];
}
const InvoicePDF = (props: InvoicePDFProps) => {
  const fileCdnData = props.invoice?.data?.invoice?.file || {};
  return (
    <>
      {fileCdnData && (
        <CDNLink
          assetType={AssetTypes.Invoicing.Invoice}
          assetId={props.invoice?._id}
          assetField={"data.invoice.file"}
          cdnId={fileCdnData.id}
          filename={fileCdnData.filename}
          fileKey={fileCdnData.key}
          hasFolderReadPermissions={true}
          render={(url) => (
            <PDFViewer
              zoomFactorStorageKey={"pdf_zoom_factor_full_view"}
              url={url}
              highlights={props.highlights}
              filename={fileCdnData.filename}
            />
          )}
        />
      )}
    </>
  );
};

export default InvoicePDF;
